<template lang="pug">
div
  app-modal-cruzamento-camada(
    v-if="showModalCamadas"
    @close="visualizarCruzamentoCamadas"
    :cruzamento="cruzamentoCamada.json"
  )
  app-divider(label="Georreferenciamento")
  .pad
    div(v-if="localizacoes && localizacoes.length")
      app-resumo-mapa(
        :key="mapaKey"
        :localizacoes="localizacoes",
        :id-mapa="idMapa",
        :isVisualizarCadastro="true"
      )
      div.btn(v-if="idProcesso")
        el-button(
          @click="downloadShape"
        )
          i.fal.fa-download
          | &nbsp Download do shapefile
        el-button(
          @click="visualizarCruzamentoCamadas",
          v-if="cruzamentoCamada"
        )
          i.fal.fa-eye
          | &nbsp Visualizar cruzamentos
    div(v-else)
      el-row.pad5(v-if="geo.responsavel")
        el-col(:span="12")
          p
            span.label Responsável:
            span &nbsp {{filterNull(geo.responsavel.nome)}}
        el-col(:span="12")
          p
            span.label Formação:
            span &nbsp {{filterNull(geo.responsavel.formacao)}}
        el-col(:span="12")
          p
            span.label CREA ou RNP:
            span &nbsp {{filterNull(geo.responsavel.creaRnp)}}
        el-col(:span="12")
          p
            span.label Código de credenciamento junto ao INCRA:
            span &nbsp {{filterNull(geo.responsavel.codigoIncra)}}

    app-resumo-documentos(
      :documentos="geo.documentos",
      v-if="geo.documentos.length",
    )
</template>

<script>
import AppDivider from '@/components/AppDivider'
import { mapActions } from 'vuex'
import AppResumoDocumentos from './AppResumoDocumentos'
import AppResumoMapa from '@/components/resumo/AppResumoMapa'
import AppDisplay from '@/components/AppDisplay'
import AppModalCruzamentoCamada from '@/components/AppModalCruzamentoCamada'

export default {
  components: {
    AppDivider,
    AppResumoDocumentos,
    AppResumoMapa,
    AppDisplay,
    AppModalCruzamentoCamada
  },

  props: {
    geo: {
      type: Object,
      required: true
    },
    localizacao: {
      type: Object,
      required: false
    },
    cruzamentoCamada: {
      type: Object,
      required: false
    },
    idMapa: {
      type: String,
      default: 'mapaResumo'
    },
    exibeDocumentos: {
      type: Boolean,
      default: true
    },
    isVisualizarCadastro: {
      type: Boolean,
      default: false
    },

    isGeoBeneficiario: {
      type: Boolean,
      default: true
    },
    isCadastroOff: {
      type: Boolean,
      default: false
    },
    idProcesso: {
      type: Number,
      required: false
    },
    showMapa: {
      type: Boolean,
      default: true
    },
    possuiCredenciadoGeo: {
      type: Boolean
    },
    compararResumoGeo: {
      type: Object,
      required: false
    }
  },

  data () {
    return {
      showModalCamadas: false,
      mapaKey: 1
    }
  },

  computed: {
    localizacoes () {
      return this.geo?.localizacoes ? this.extractCoordinates(this.geo.localizacoes) : []
    }
  },

  methods: {
    ...mapActions({
      shape: 'processo/shape'
    }),

    extractCoordinates (localizacoes) {
      return localizacoes.map(loc => loc.geometry)
    },

    visualizarCruzamentoCamadas () {
      this.showModalCamadas = !this.showModalCamadas
    },

    async downloadShape () {
      await this.shape(this.idProcesso)
    },

    filterNull (atributo) {
      if (!atributo || atributo.length === 0) {
        return '-'
      }
      return atributo
    }
  },

  watch: {
    localizacoes: {
      handler (val) {
        this.mapaKey += 1
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.pad {
  padding: 15px 5px;
}

.pad5 {
  padding: 25px 10px;
}

.margin-top {
  margin-top:25px;
}

.btn {
  margin-top: 12px;
  text-align: right;
}

.label {
  font-weight: bold;
}

</style>



// WEBPACK FOOTER //
// src/screens/central/cadastros/para/retificacao/components/resumos/AppResumoGeo.vue